export default function (state = [], action) {
    switch (action.type) {
        case "SHOW_QUERIES":
            return action.payload
            break;
        default:
            return state;
    }
}